import { FC, MouseEventHandler, useEffect, useState } from "react";
import { Answer } from "../../store/answer";
import { PlusCircle as PlusCircleIcon, Trash2 as Trash2Icon } from "react-feather";
import { FavoriteEntry } from "../../store/favorite";
import { ApplicationState, AppThunkDispatch } from "../../store";
import { favoriteActionCreators } from "../../actions/favoriteActions";
import { connect, ConnectedProps } from "react-redux";
import AddFavoriteEntryModal from "./AddFavoriteEntryModal";
import DeleteFavoriteEntryModal from "./DeleteFavoriteEntryModal";

interface AddFavoriteEntryButtonsProps extends ConnectedProps<typeof connector> {
    answer: Answer;
    onDelete: (FavoriteEntry: FavoriteEntry) => void;
}

const AddFavoriteEntryButtons: FC<AddFavoriteEntryButtonsProps> = (props) => {
    const [showAddFavoriteEntryModal, setShowAddFavoriteEntryModal] = useState(false);
    const [favoriteEntryToDelete, setFavoriteEntryToDelete] = useState<FavoriteEntry | null>(null);

    const { answer } = props;
    const { favoriteState } = props;
    const { readFavoriteData } = props;

    const isLoading = favoriteState.isLoading;
    const isFavorite = favoriteState.data?.favs.some(e => e.answerId === answer.id);

    const handleAddFavoriteEntryModalClose = () => {
        setShowAddFavoriteEntryModal(false);
    }

    useEffect(() => {
        if ((favoriteState.data === undefined || favoriteState.error) && !favoriteState.isLoading) {
            readFavoriteData();
        }
    }, []);

    const handleAddFavButtonClick: MouseEventHandler<HTMLButtonElement> = (event) => {
        setShowAddFavoriteEntryModal(true);
    }

    const handleFavoriteListDelete: MouseEventHandler<HTMLButtonElement> = (event) => {
        var favEntry = favoriteState.data?.favs.find(x => x.answerId === answer.id);

        if (favEntry) {
            setFavoriteEntryToDelete(favEntry);
        }
        else {
            setFavoriteEntryToDelete(null);
        }
    }

    const handleModalClose = () => {
        setFavoriteEntryToDelete(null);
    }

    const isDeleteModalVisible = favoriteEntryToDelete !== null;

    return (
        <>
            <AddFavoriteEntryModal isVisible={showAddFavoriteEntryModal} onClose={handleAddFavoriteEntryModalClose} answer={answer} />
            <DeleteFavoriteEntryModal isVisible={isDeleteModalVisible} favoriteEntry={favoriteEntryToDelete!} onClose={handleModalClose} />

            {!isFavorite && (
                <div className="button-wrapper">
                    <button className="save" disabled={isLoading} onClick={handleAddFavButtonClick}><span id="save-button-text"><PlusCircleIcon className="plus-icon" /> Add<span className="this-question-text"> Question to Favorites</span></span></button>
                </div>
            )}
            
            {isFavorite && (
                <div className="button-wrapper">
                    <button className="save" disabled={isLoading} onClick={handleFavoriteListDelete}><span id="save-button-text"><Trash2Icon className="delete-icon-answer" /> Delete<span className="this-question-text"> from Favorites</span></span></button>
                </div>
            )}
        </>
    );
}

const mapStateToProps = (state: ApplicationState) => {
    const favoriteState = state.favorite;

    return { favoriteState };
}

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    readFavoriteData: () => {
        dispatch(favoriteActionCreators.readFavoriteData());
    }
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(AddFavoriteEntryButtons);